/*eslint linebreak-style: ["error", "windows"]*/

export default class ApiWrapper {

	constructor(base_url = null) {
			if (base_url) {
					this.base_url = base_url;
			} else {
					this.base_url = 'http://localhost:1337';
			}
	}

	sendRequest(url, options, token = null) {

			/** @todo - dirty hack. need to provide better solution */
			if(url === '/api/game/all') {
				url = this.base_url + url;
				options.headers = {
					'X-Consumer-Token': this.getToken()
				};
				if (options.queryParams) {
						url += (url.indexOf('?') === -1 ? '?' : '&') + this.queryParams(options.queryParams);
						delete options.queryParams;
				}
				return fetch(url, options);
			}


			if (token) {
					if (this.validateToken()) {
							options.headers = {
									'X-Consumer-Token': this.getToken()
							};
					} else {
							return Promise.reject(new Error('You are not authorised to make this request. Please login'));
					}
			}

			url = this.base_url + url;

			if (options.queryParams) {
					url += (url.indexOf('?') === -1 ? '?' : '&') + this.queryParams(options.queryParams);
					delete options.queryParams;
			}

			return fetch(url, options);
	}

	queryParams(params) {
			return Object.keys(params)
					.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
					.join('&');
	}

	getSuccessResponse(response) {
			return {
					code: response.status.code,
					name: response.status.name,
					data: response.data
			};
	}

	getErrorResponse(response) {
			return {
					code: response.status.code,
					name: response.status.name,
					message: response.error
			};
	}

	login(email, password) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('email', email);
			formData.append('password', password);

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/authentication/login', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											this.setToken(obj.data);
											obj.data = 'User has been logged in.';
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addUser(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'POST');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/user/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											const anchor = document.createElement('a');
											anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(obj.data);
											anchor.target = '_blank';
											anchor.download = 'nameYourFileHere.csv';
											anchor.click();
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editUser(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'PUT');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/user/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getAllUsers(userType = null) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {

					this.sendRequest('/api/users/getAll?type=' + userType, options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getUserByToken(token) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {

					this.sendRequest('/api/user/' + token, options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getActiveUser() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/user/active', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getUser(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/user/get?id=' + parseInt(id), options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	triggerForgottenPassword(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();
			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/user/reset-password/id', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	triggerForgottenPasswordByEmail(email) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();
			formData.append('email', email);

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/user/reset-password/email', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	updatePassword(token, password) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('token', token);
			formData.append('password', password);

			options.body = formData;

			return new Promise((resolve, reject) => {

					this.sendRequest('/api/user/update-password', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deleteUser(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/user/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addGame(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (params.assets) {
					for (var k in params.assets) {
							if (params.assets[k]) {
									params.assets[k].forEach((file, index) => {
											if (file['id']) {
													formData.append(`files[${k}][${index}][id]`, file['id']);
													delete params.assets[k][index]['id'];
											}

											if (file['data']) {
													formData.append(`files[${k}][${index}][data]`, file['data']);
													delete params.assets[k][index]['data'];
											}

									});
									formData.append(`assets[${k}]`, this.stringifySafe(params.assets[k]));
							}
					}
			}

			// //Files have already been prepared so remove them from the params so they are not resent.
			delete params.assets;

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'POST');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editGame(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (params.assets) {
					for (var k in params.assets) {
							if (params.assets[k]) {
									params.assets[k].forEach((file, index) => {
											if (file['id']) {
													formData.append(`files[${k}][${index}][id]`, file['id']);
													delete params.assets[k][index]['id'];
											}

											if (file['data']) {
													formData.append(`files[${k}][${index}][data]`, file['data']);
													delete params.assets[k][index]['data'];
											}

									});
									formData.append(`assets[${k}]`, this.stringifySafe(params.assets[k]));
							}
					}
			}

			// //Files have already been prepared so remove them from the params so they are not resent.
			delete params.assets;

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'PUT');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getGame(id, isActive = null) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/game/get?id=' + parseInt(id) + '&isActive=' + isActive, options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getGameByName(name, isActive = null) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/name?name=' + name + '&isActive=' + isActive, options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getGameByIds(ids, isActive = null) {
			const options = {
					method: 'GET'
			};

			ids = ids.join(':');

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/ids?ids=' + ids + '&isActive=' + isActive, options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getGameByReleaseDate(date, isActive = null) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('date', date);

			if (isActive !== null) {
					formData.append('isActive', isActive);
			}

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/date', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getAllGames(isActive = null, depth = null, regions = null) {
			const options = {
					method: 'POST'
			};

			if (isActive !== null || depth !== null || regions !== null) {
					const formData = new FormData();

					if (isActive !== null) {
							formData.append('isActive', isActive);
					}

					if (depth !== null) {
							formData.append('depth', depth);
					}

					if (regions !== null) {
							formData.append('regions', JSON.stringify(regions));
					}

					options.body = formData;
			}

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/all', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getFeaturedGames(isActive = null) {
			const options = {
					method: 'POST'
			};

			if (isActive !== null) {
					const formData = new FormData();

					formData.append('isActive', isActive);

					options.body = formData;
			}

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/game/featured', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deleteGame(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/game/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	putAsset(files, folder = null) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (folder) {
					formData.append('folder', folder);
			}

			[...files].forEach((file, i) => {
					formData.append(`files[${i}]`, file);
			});

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/asset/put', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	putAssetsInParentId(files, parentId)
	{
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			[...files].forEach((file, i) => {
					formData.append(`files[${i}]`, file);
			});
			formData.append('parentId', parentId);

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/asset/putIntoParent', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getAsset(id) {
			const options = {
					method: 'GET'
			};

			if (this.validateToken()) {
					options.headers = {
							'X-Consumer-Token': this.getToken()
					};
			}

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/asset/' + parseInt(id, 10), options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getAssetDirectory(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/asset/directory?id=' + parseInt(id, 10), options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getGameAssetDirectory(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/asset/game/directory?id=' + parseInt(id, 10), options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getUserAssetDirectory(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/asset/user/directory?id=' + parseInt(id, 10), options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getDocumentCentreId(folderId) {
			const options = {
					method: 'GET'
			};

			if (this.validateToken()) {
					options.headers = {
							'X-Consumer-Token': this.getToken()
					};
			}

			return new Promise((resolve, reject) => {
					var url = '/api/asset/get/documentCentre';
					if(folderId) {
						url = '/api/asset/get/documentCentre?folderId=' + parseInt(folderId, 10);
					}

					this.sendRequest(url, options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getFinancialDocumentCentreId() {
			const options = {
					method: 'GET'
			};

			if (this.validateToken()) {
					options.headers = {
							'X-Consumer-Token': this.getToken()
					};
			}

			return new Promise((resolve, reject) => {

					this.sendRequest('/api/asset/get/financialDocumentCentre', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deleteAsset(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/asset/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	renameAsset(id, name) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);
			formData.append('name', name);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/asset/rename', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	moveAssets(ids, parentId) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			ids = ids.join(':');
			formData.append('ids', ids);
			formData.append('parentId', parentId);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(parentId)) {
							return reject(new Error('Parent id provided is invalid'));
					}

					this.sendRequest('/api/asset/move', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	newFolder(parentId, name) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('pid', parentId);
			formData.append('name', name);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(parentId)) {
							return reject(new Error('Parent Id provided is invalid'));
					}

					this.sendRequest('/api/asset/create/folder', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addRoadmap(params) {
			const options = {
					method: 'POST'
			};

			options.body = this.stringifySafe(params);

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/roadmap/put', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addOperator(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (params.assets) {
					for (var k in params.assets) {
							if (params.assets[k]) {
									params.assets[k].forEach((file, index) => {
											if (file['id']) {
													formData.append(`files[${k}][${index}][id]`, file['id']);
													delete params.assets[k][index]['id'];
											}

											if (file['data']) {
													formData.append(`files[${k}][${index}][data]`, file['data']);
													delete params.assets[k][index]['data'];
											}

									});
									formData.append(`assets[${k}]`, this.stringifySafe(params.assets[k]));
							}
					}
			}

			// //Files have already been prepared so remove them from the params so they are not resent.
			delete params.assets;

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'POST');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/operator/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editOperator(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (params.assets) {
					for (var k in params.assets) {
							if (params.assets[k]) {
									params.assets[k].forEach((file, index) => {
											if (file['id']) {
													formData.append(`files[${k}][${index}][id]`, file['id']);
													delete params.assets[k][index]['id'];
											}

											if (file['data']) {
													formData.append(`files[${k}][${index}][data]`, file['data']);
													delete params.assets[k][index]['data'];
											}

									});
									formData.append(`assets[${k}]`, this.stringifySafe(params.assets[k]));
							}
					}
			}

			// //Files have already been prepared so remove them from the params so they are not resent.
			delete params.assets;

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'PUT');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/operator/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getOperators() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/operator/get', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getOperator(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/operator/' + parseInt(id), options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deleteOperator(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/operator/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addPartner(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (params.assets) {
					for (var k in params.assets) {
							if (params.assets[k]) {
									params.assets[k].forEach((file, index) => {
											if (file['id']) {
													formData.append(`files[${k}][${index}][id]`, file['id']);
													delete params.assets[k][index]['id'];
											}

											if (file['data']) {
													formData.append(`files[${k}][${index}][data]`, file['data']);
													delete params.assets[k][index]['data'];
											}

									});
									formData.append(`assets[${k}]`, this.stringifySafe(params.assets[k]));
							}
					}
			}

			// //Files have already been prepared so remove them from the params so they are not resent.
			delete params.assets;

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'POST');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/partner/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editPartner(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			if (params.assets) {
					for (var k in params.assets) {
							if (params.assets[k]) {
									params.assets[k].forEach((file, index) => {
											if (file['id']) {
													formData.append(`files[${k}][${index}][id]`, file['id']);
													delete params.assets[k][index]['id'];
											}

											if (file['data']) {
													formData.append(`files[${k}][${index}][data]`, file['data']);
													delete params.assets[k][index]['data'];
											}

									});
									formData.append(`assets[${k}]`, this.stringifySafe(params.assets[k]));
							}
					}
			}

			// //Files have already been prepared so remove them from the params so they are not resent.
			delete params.assets;

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'PUT');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/partner/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getPartners() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/partner/get', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getPartner(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/partner/' + parseInt(id), options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deletePartner(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/partner/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addCategory(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'POST');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/category/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editCategory(params) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			for (const key in params) {
					formData.append(key, params[key]);
			}

			formData.append('type', 'PUT');

			options.body = formData;

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/category/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getCategories() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/category/get', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getCategory(id) {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/category/' + parseInt(id), options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deleteCategory(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/category/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	uploadGameAssets(params) {
			const options = {
					method: 'POST'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/asset/game', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	addNews(params) {
			const options = {
					method: 'POST'
			};

			options.body = JSON.stringify(params);

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/news/add', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editNews(params) {
			const options = {
					method: 'POST'
			};

			options.body = JSON.stringify(params);

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/news/edit', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getNews(id = null, limit = null, offset = null, featured = null, tag = null, regions = []) {
			const options = {
					method: 'GET',
					queryParams: {},
			};

			if (id || limit || offset) {
					options.queryParams = {
							id: id,
							limit: limit,
							offset: offset,
							featured: featured,
							tag: tag,
					};
			}

			if (regions && regions.length > 0) {
					options.queryParams.regions = JSON.stringify(regions);
			}

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/news/get', options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getNewsTags() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/news/gettags', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getNewsAssets() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/news/getstoredassets', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	deleteNews(id) {
			const options = {
					method: 'POST'
			};

			const formData = new FormData();

			formData.append('id', id);

			options.body = formData;

			return new Promise((resolve, reject) => {
					if (isNaN(id)) {
							return reject(new Error('Id provided is invalid'));
					}

					this.sendRequest('/api/news/delete', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getHomepageAssets() {
			const options = {
					method: 'GET'
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/content/getstoredassets', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getHomepage(params) {
			return this.getPage('homepage', params);
	}

	editHomepage(params) {
			return this.editPage('homepage', params);
	}

	getGamepage(params) {
			return this.getPage('gamepage', params);
	}

	editGamepage(params) {
			return this.editPage('gamepage', params);
	}

	getAssetManagerpage(params) {
			return this.getPage('assetmanagerpage', params);
	}

	editAssetManagerpage(params) {
			return this.editPage('assetmanagerpage', params);
	}

	getRoadmappage(params) {
			return this.getPage('roadmappage', params);
	}

	editRoadmappage(params) {
			return this.editPage('roadmappage', params);
	}

	getAboutUspage(params) {
		return this.getPage('aboutuspage', params);
	}

	editAboutUspage(params) {
		return this.editPage('aboutuspage', params);
	}

	getSportspage(params) {
		return this.getPage('sportspage', params);
	}

	editSportspage(params) {
		return this.editPage('sportspage', params);
	}

	getCasinopage(params) {
		return this.getPage('casinopage', params);
	}

	editCasinopage(params) {
		return this.editPage('casinopage', params);
	}

	getPromotionalToolsPage(params) {
			return this.getPage('promotionaltools', params);
	}

	editPromotionalToolsPage(params) {
			return this.editPage('promotionaltools', params);
	}

	editPromotionalToolsModules(params) {
			return this.editPageModules(params);
	}

	getPage(pagealias, params) {
			const options = {
					method: 'GET'
			};

			if(params)
			{
				options.queryParams = params;
			}

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/content/get' + pagealias, options)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editPage(pagealias, params) {
			const options = {
					method: 'POST'
			};

			options.body = JSON.stringify(params);

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/content/edit' + pagealias, options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	editPageModules(params) {
			const options = {
					method: 'POST'
			};

			options.body = JSON.stringify(params);

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/content/edit' + 'promotionaltoolsmodules', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	getLogs(id = null, limit = null, offset = null) {
			const options = {
					method: 'GET'
			};

			if (id || limit || offset) {
					options.queryParams = {
							id: id,
							limit: limit,
							offset: offset
					};
			}

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/logs/get', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	createLog(description, user = null, game = null, data = null) {
			const options = {
					method: 'POST',
					queryParams: {
							description: description,
							user: user,
							game: game,
							data: (typeof data !== 'string' ? JSON.stringify(data) : data)
					}
			};

			return new Promise((resolve, reject) => {
					this.sendRequest('/api/logs/create', options, true)
							.then(res => res.json())
							.then(obj => {
									if (obj.success) {
											resolve(this.getSuccessResponse(obj));
									} else {
											reject(this.getErrorResponse(obj));
									}
							})
							.catch(reject);
			});
	}

	setToken(token) {
			localStorage.setItem('jwtToken', token);
	}

	getToken() {
			return localStorage.getItem('jwtToken');
	}

	validateToken() {
			const token = this.getToken();

			if (token) {
					try {
							let [type, params] = token.split('.').slice(0, 2).map(tok => window.atob(tok));

							params = JSON.parse(params);

							if (new Date() < new Date(params.expiry_time * 1000)) {
									return true;
							}
					} catch (e) {
							return false;
					}
			}

			return false;
	}

	stringifySafe(string) {
			try {
					return JSON.stringify(string);
			} catch (ex) {
					//TODO - Create some kind of unique error message we can grab and log.
					return '{There was an error}';
			}
	}

	downloadRoadmapCsv(params) {
		const options = {
				method: 'GET'
		};

		if(params)
		{
			options.queryParams = params;
		}
		return new Promise((resolve, reject) => {
				this.sendRequest('/api/content/downloadroadmapcsv', options, true)
						.then(res => res.json())
						.then(obj => {
								if (obj.success) {
									const anchor = document.createElement('a');
									anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(obj.data.file);
									anchor.target = '_blank';
									anchor.download = obj.data.filename
									anchor.click();
									resolve(this.getSuccessResponse(obj));
								} else {
									reject(this.getErrorResponse(obj));
								}
						})
						.catch(reject);
		});
	}

}



// WEBPACK FOOTER //
// ./includes/ApiWrapper.js